import { BASE_URL, FEATURE_SETTINGS_ENDPOINT, SOMS_API_KEY } from "services/CONSTANTS";
import { BULK_DELETE_MAX_CAP_FAILURE, BULK_DELETE_MAX_CAP_REQUEST, BULK_DELETE_MAX_CAP_RESET, BULK_DELETE_MAX_CAP_SUCCESS } from "./action-type";
import { BulkDeleteMOQ } from "services/apiService";

export const bulkDeleteMaxCapAction = (payload) => {
    return (dispatch) => {
        dispatch(bulkDeleteMaxCapRequest());
         const apiUrl = `${BASE_URL}${FEATURE_SETTINGS_ENDPOINT}?apikey=${SOMS_API_KEY}`;
        const request = {
            url: apiUrl,
            params: payload,
        };
        BulkDeleteMOQ(request)
            .then((response) => {
                if (response.status === 200 || response.status === 204) {
                    dispatch(bulkDeleteMaxCapSuccess(response));
                } else {
                    dispatch(bulkDeleteMaxCapFailure(response));
                }
            })
            .catch((err) => {
                dispatch(bulkDeleteMaxCapFailure(err));
            });
    };
};

const bulkDeleteMaxCapRequest = () => ({
    type: BULK_DELETE_MAX_CAP_REQUEST,
});

const bulkDeleteMaxCapSuccess = (response) => ({
    type: BULK_DELETE_MAX_CAP_SUCCESS,
    bulkDeleteMaxCapResponse: response,
});

const bulkDeleteMaxCapFailure = (error) => ({
    type: BULK_DELETE_MAX_CAP_FAILURE,
    bulkDeleteMaxCapResponse: error,
});

export const bulkDeleteMaxCapReset = () => ({
    type: BULK_DELETE_MAX_CAP_RESET,
});
